import { Currency } from "../domain/currency";

export const roundCurrency = (value: number, currency: Currency): number => {
  return currency === 'CLP' ? Math.round(value) : parseFloat(value?.toFixed(2));
}

export const numberFormat = (value: number): string => {
  const float = value.toString().split('.');
  const formatedInteger = float[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  return float[1] ? formatedInteger.concat(`,${float[1]}`) : formatedInteger;
};

export const currencyFormat = (value: number, currency: Currency, round?: boolean): string => {
  const roundedValue = roundCurrency(value, currency);
  if (round) {
    return currency === 'CLP'
      ? `$${numberFormat(roundedValue)}`
      : `UF ${numberFormat(roundedValue)}`;
  }
  return currency === 'CLP'
    ? `$${numberFormat(roundedValue)}`
    : `UF ${numberFormat(value)}`;
};
